<template>
  <a-date-picker
    :value="field.value"
    :format="config.format"
    :value-format="config.format"
    :placeholder="config.placeholder || `请选择${field.label || ''}`"
    :disabled-date="config.disabledDate"
    @change="handleChange"
  />
</template>
<script>
import { defineComponent } from 'vue'
import { props } from './helper'
export default defineComponent({
  props,
  setup () {
    return {}
  }
})
</script>
<style lang='scss' scoped>
</style>
